import { useTranslation } from "react-i18next";
import { useToast } from "../hooks/useToast";

const typeStyles = {
  success: "bg-green-600",
  error: "bg-red-600",
  info: "bg-gray-800",
};

export function ToastContainer() {
  const { t } = useTranslation();
  const { toasts, removeToast } = useToast();

  if (toasts.length === 0) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`${typeStyles[toast.type]} animate-slide-in rounded-lg px-4 py-3 text-sm text-white shadow-lg`}
          role="alert"
        >
          <div className="flex items-center justify-between gap-3">
            <p>{toast.message}</p>
            <button
              onClick={() => removeToast(toast.id)}
              className="text-white/70 hover:text-white"
              aria-label={t("common.dismiss")}
            >
              &times;
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
